module.exports = __webpack_public_path__ + "img/sweetme.f67f30aa.png";